export enum ShippingMethodMatrixBasis {
    Weight = 'weight',
    Quantity = 'quantity',
    OrderValue = 'order_value',
    Attribute = 'attribute',
}